import React, { useEffect } from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { PartnerLogos } from './components/PartnerLogos';
import { Stats } from './components/Stats';
import { Services } from './components/Services';
import { Advantages } from './components/Advantages';
import { Testimonial } from './components/Testimonial';
import { News } from './components/News';
import { Newsletter } from './components/Newsletter';
import { Footer } from './components/Footer';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
// Existing pages
import { KnowledgeHub } from './pages/KnowledgeHub';
import { Compliance } from './pages/pillars/Compliance';
import { MaintenanceGuide } from './pages/pillars/MaintenanceGuide';
import { InstallationGuide } from './pages/pillars/InstallationGuide';
import { RepairsEfficiency } from './pages/pillars/RepairsEfficiency';
import { EcoVentilation } from './pages/pillars/EcoVentilation';
import { HomeV2 } from './pages/HomeV2';
// New pages
import { ServicesOverview } from './pages/ServicesOverview';
import { WhyAccuTemp } from './pages/WhyAccuTemp';
import { CaseStudies } from './pages/CaseStudies';
import { About } from './pages/About';
import { Contact } from './pages/Contact';
import { Installation } from './pages/services/Installation';
import { Maintenance } from './pages/services/Maintenance';
import { TM44 } from './pages/services/TM44';
import { Ventilation } from './pages/services/Ventilation';
function ScrollToTop() {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);
  return null;
}
function HomePage() {
  return <main id="main-content" data-id="element-0">
      <Hero data-id="element-1" />
      <PartnerLogos data-id="element-2" />
      <Stats data-id="element-3" />
      <Services data-id="element-4" />
      <Advantages data-id="element-5" />
      <Testimonial data-id="element-6" />
      <News data-id="element-7" />
      <Newsletter data-id="element-8" />
    </main>;
}
function AppLayout() {
  const location = useLocation();
  const hideNavbar = location.pathname.startsWith('/home-v2');
  return <div className="min-h-screen bg-white font-sans selection:bg-accent/20 selection:text-primary-dark" data-id="element-9">
      <ScrollToTop data-id="element-10" />
      <a href="#main-content" className="sr-only focus:not-sr-only focus:fixed focus:top-4 focus:left-4 focus:z-[100] focus:bg-accent focus:text-white focus:px-4 focus:py-2 focus:rounded-lg focus:text-sm focus:font-medium" data-id="element-11">
        Skip to main content
      </a>
      {!hideNavbar && <Navbar data-id="element-12" />}
      <Routes data-id="element-13">
        <Route path="/" element={<HomePage data-id="element-15" />} data-id="element-14" />
        <Route path="/home-v2" element={<HomeV2 data-id="element-17" />} data-id="element-16" />

        {/* Core Pages */}
        <Route path="/services" element={<ServicesOverview data-id="element-19" />} data-id="element-18" />
        <Route path="/why-accutemp" element={<WhyAccuTemp data-id="element-21" />} data-id="element-20" />
        <Route path="/case-studies" element={<CaseStudies data-id="element-23" />} data-id="element-22" />
        <Route path="/about" element={<About data-id="element-25" />} data-id="element-24" />
        <Route path="/contact" element={<Contact data-id="element-27" />} data-id="element-26" />

        {/* Service Detail Pages */}
        <Route path="/services/installation" element={<Installation data-id="element-29" />} data-id="element-28" />
        <Route path="/services/maintenance" element={<Maintenance data-id="element-31" />} data-id="element-30" />
        <Route path="/services/tm44" element={<TM44 data-id="element-33" />} data-id="element-32" />
        <Route path="/services/ventilation" element={<Ventilation data-id="element-35" />} data-id="element-34" />

        {/* Resources / Knowledge Hub */}
        <Route path="/knowledge-hub" element={<KnowledgeHub data-id="element-37" />} data-id="element-36" />
        <Route path="/knowledge-hub/compliance" element={<Compliance data-id="element-39" />} data-id="element-38" />
        <Route path="/knowledge-hub/maintenance-guide" element={<MaintenanceGuide data-id="element-41" />} data-id="element-40" />
        <Route path="/knowledge-hub/installation-guide" element={<InstallationGuide data-id="element-43" />} data-id="element-42" />
        <Route path="/knowledge-hub/repairs-efficiency" element={<RepairsEfficiency data-id="element-45" />} data-id="element-44" />
        <Route path="/knowledge-hub/eco-ventilation" element={<EcoVentilation data-id="element-47" />} data-id="element-46" />
      </Routes>
      <Footer data-id="element-48" />
    </div>;
}
export function App() {
  return <BrowserRouter data-id="element-49">
      <AppLayout data-id="element-50" />
    </BrowserRouter>;
}